/**************************************************
 * Nombre:       Home_Contactos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import LineaDatos from "./SubComponentes/LineaDatos";
import {WhatsApp} from '@mui/icons-material'
import Tarjeta_Dato from "../../Tarjetas/Tarjeta_Dato";
import ic_envio from '../../../Recursos/ic_envio.svg'
import ic_calidad from '../../../Recursos/ic_calidad.svg'
import ic_mercado from '../../../Recursos/ic_mercado.svg'
import ic_servicio from '../../../Recursos/ic_servicio.svg'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {CONTACTOS} from "../../../Constantes";
import {irUrl} from "../../../Utilidades/irUrl";


const Home_Contactos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d797.45335038192!2d-96.78008150064483!3d16.825240672796514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1ses!2sco!4v1777382662776!5m2!1ses!2sco"
                    width={'100%'} height="550" style={{border: 0, filter: 'grayscale(100%)'}} allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, zIndex: 2}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 6, md: 4}}
                    sx={{backgroundColor: '#fff', p: 6, mt: sCell ? -10 : -62, boxShadow: sCell ? 4 : 0}}
                >

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 20, fontWeight: 400, lineHeight: 1.1}}>ENCUENTRANOS</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 20, fontWeight: 700}}>VISITANOS </Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                        <LineaDatos item={CONTACTOS[0]}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <LineaDatos item={CONTACTOS[1]}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <LineaDatos item={CONTACTOS[2]}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                        <Button
                            onClick={() => irUrl(CONTACTOS[1].url)}
                            fullWidth
                            startIcon={<WhatsApp/>}
                            sx={{pt: 1.8, pb: 1.8}}
                        >Contactanos ahora</Button>
                    </Grid>


                </Grid>


                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={sCell ? 2 : 6}
                    sx={{mt: 6}}
                >

                    {items.map((item, index) => (
                        <Grid container size={{xs: 12, sm: 6, md: 3}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Dato item={item}/>
                        </Grid>
                    ))}


                </Grid>

            </Grid>


        </Grid>
    )

}
export default Home_Contactos

const items = [
    {
        nombre: 'Envios Gratis',
        descripcion: 'De acuerdo al sector y monto',
        img: ic_envio
    },
    {
        nombre: 'Calidad Garantizada',
        descripcion: 'Solo las mejores marcas',
        img: ic_calidad
    },
    {
        nombre: 'Pago seguro',
        descripcion: 'Mercado pago asegura tu compra',
        img: ic_mercado
    },
    {
        nombre: 'Servicio Personalizado',
        descripcion: 'Tu eres importante no uno mas',
        img: ic_servicio
    },
]

